import React, { Component } from 'react';
import Titulo from '../../components/Texto/Titulo';
import Voltar from '../../components/Links/Voltar';

import { connect } from 'react-redux';
import * as actionsProdutos from '../../actions/produtos';
import * as actionsCategorias from '../../actions/categorias';
import AlertGeral from '../../components/Alert/Geral';
import { Link } from 'react-router-dom';

import InputSimples from '../../components/Inputs/Simples';
import TextAreaSimple from '../../components/Inputs/TextAreaSimple';
import SearchCategories from '../../components/Search/Categories';
import { formatMoney, formatMoneyOnChange } from '../../utils';
import erpApi from '../../services/erpApi';

class NovoProduto extends Component {

    state = {
        nome: "",
        descricao: "",
        categoria: [],
        preco: "",
        promocao: "",
        erpId: "",
        aviso: null,
        erros: {},
        categoriesItems: [],
        success: false,
        erpConsultaLoading: false,
        erpConsultaResultado: null,
        erpConsultaErro: null
    }

    getCategorias(props){
        const { usuario, getCategorias } = props;
        if(usuario) getCategorias(usuario.loja);
    }

    componentDidMount(){
        this.getCategorias(this.props);
    }
    componentDidUpdate(prevProps){
        if( !prevProps.usuario && this.props.usuario ) this.getCategorias(this.props);
    }

    searchCategories = (search) => {
		const _searchFormatted = search.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");

		const _search = this.props.categorias.filter(fiItem => fiItem.nome.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(_searchFormatted))
        return this.setState({ categoriesItems: _search });
    }

	callbackCategories = (data) => {
		return this.setState({ categoria: data })
    }

    validate(){
        const { nome, descricao, categoria, preco } = this.state;
        const erros = {};

        if(!nome) erros.nome = "Preencha aqui com o nome do produto";
        if(!categoria) erros.categoria = "Preencha aqui com a categoria do produto";
        if(!descricao) erros.descricao = "Preencha aqui com a descrição do produto";
        if(!preco) erros.preco = "Preencha aqui com o preço do produto";

        this.setState({ erros });
        return !( Object.keys(erros).length > 0 );
    }

    goAdd(){
        const { usuario, salvarProduto } = this.props;
        if(!usuario) return null;
        
        if(!this.validate()) return null;

        salvarProduto(this.state, usuario.loja, (error) => {
            this.setState({ aviso: { status: !error, msg: error ? error.message : "Produto criado com sucesso" } });
            !error && this.setState({ success: true })
        });
    }

    onChangeInput = (field, value) => this.setState({ [field]: value })

    consultarERP = async () => {
        const { erpId } = this.state;
        
        if (!erpId) {
            return this.setState({
                aviso: {
                    status: false,
                    msg: "Informe um ID no ERP para consultar"
                }
            });
        }
        
        this.setState({
            erpConsultaLoading: true,
            erpConsultaResultado: null,
            aviso: null
        });
        
        try {
            const resultado = await erpApi.getProdutoByCodigo(erpId);
            
            if (resultado.success) {
                this.setState({
                    erpConsultaResultado: resultado.data,
                    erpConsultaLoading: false,
                    aviso: {
                        status: true,
                        msg: "Produto encontrado no ERP com sucesso!"
                    }
                });
                
                // Auto-preencher campos com dados do ERP
                if (resultado.data && resultado.data.length > 0) {
                    const produtoERP = resultado.data[0];
                    this.setState({
                        nome: produtoERP.nome || this.state.nome,
                        descricao: produtoERP.descricao || this.state.descricao,
                        preco: produtoERP.preco ? formatMoney(produtoERP.preco) : this.state.preco
                    });
                }
            } else {
                this.setState({
                    erpConsultaLoading: false,
                    aviso: {
                        status: false,
                        msg: resultado.error?.message || "Produto não encontrado no ERP ou erro na consulta"
                    }
                });
            }
        } catch (error) {
            this.setState({
                erpConsultaLoading: false,
                aviso: {
                    status: false,
                    msg: `Erro ao consultar ERP: ${error.message}`
                }
            });
        }
    }

    renderErpConsultaResultado() {
        const { erpConsultaResultado } = this.state;
        
        if (!erpConsultaResultado || erpConsultaResultado.length === 0) return null;
        
        const produto = erpConsultaResultado[0];
        
        return (
            <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #e9ecef' }}>
                <h4 style={{ fontSize: '14px', marginBottom: '8px', color: '#28a745' }}>Produto encontrado no ERP</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px' }}>
                    {produto.codigo && (
                        <div>
                            <strong>Código:</strong> {produto.codigo}
                        </div>
                    )}
                    {produto.nome && (
                        <div>
                            <strong>Nome:</strong> {produto.nome}
                        </div>
                    )}
                    {produto.preco !== undefined && (
                        <div>
                            <strong>Preço:</strong> {formatMoney(produto.preco)}
                        </div>
                    )}
                    {produto.quantidade !== undefined && (
                        <div>
                            <strong>Estoque:</strong> {produto.quantidade}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderDados(){
        const { nome, descricao, categoria, preco, promocao, erpId, erros, aviso, erpConsultaLoading } = this.state;
        const { categorias } = this.props;

        if(!categoria || !categorias) return null;

		var _currentCategories = [];
		categorias.filter(fiItem => categoria.map(item => fiItem._id === item && _currentCategories.push(fiItem)))

        return (
            <div className="content">
                <div className="Page-Title">
                    <Titulo tipo="h1" titulo="Novo Produto"/>
                    <AlertGeral aviso={aviso} />
                </div>

                <InputSimples type="text" label="Nome" value={nome} onChange={(e) => this.onChangeInput("nome", e.target.value)} error={erros.nome} />

                <TextAreaSimple type="text" label="Descrição" value={descricao} onChange={(e) => this.onChangeInput("descricao", e.target.value)} error={erros.descricao} />
                
                <InputSimples type="text" label="Preço" value={preco} onChange={(e) => this.onChangeInput("preco", formatMoneyOnChange(e.target.value))} error={erros.preco} />

                <InputSimples type="text" label="Valor Promocional" value={promocao} onChange={(e) => this.onChangeInput("promocao", formatMoneyOnChange(e.target.value))} error={erros.promocao} />

                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    <div style={{ flex: 1 }}>
                        <InputSimples type="text" label="ID no ERP" value={erpId} onChange={(e) => this.onChangeInput("erpId", e.target.value)} error={erros.erpId} />
                    </div>
                    <div style={{ marginTop: '40px' }}>
                        <button 
                            onClick={this.consultarERP}
                            disabled={erpConsultaLoading}
                            style={{ 
                                padding: '6px 12px', 
                                backgroundColor: '#f0f0f0', 
                                color: '#333', 
                                border: '1px solid #ccc', 
                                borderRadius: '4px',
                                cursor: erpConsultaLoading ? 'wait' : 'pointer',
                                fontSize: '13px'
                            }}
                        >
                            {erpConsultaLoading ? 'Consultando...' : 'Consultar'}
                        </button>
                    </div>
                </div>

                <SearchCategories data={this.state.categoriesItems || []} currentCategories={_currentCategories || []} searchAction={(search) => this.searchCategories(search)} callback={(newData) => this.callbackCategories(newData)} />
                
                {this.renderErpConsultaResultado()}
                    
                <div className="ButtonSubmit">
                    <button onClick={() => this.goAdd()}>Criar Agora</button>
                </div>

            </div>
        )
    }

    renderSuccess(){
        return (
            <div className="success">
              <h1>Tudo certo!</h1>
              <p>Produto criado com sucesso, clique no botão abaixo para ver mais :D</p>
              <div className="action">
                <Link to={`/produtos`}>Ver Produtos</Link>
              </div>
            </div>
        )
    }

    render(){
        const { success } = this.state;

        return (
            <div className="newProduct container-centered">
                <div className="head">
					<Voltar history={this.props.history} />
				</div>
                { success ? this.renderSuccess() : this.renderDados() }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    produto: state.produto.produto,
    categorias: state.categoria.categorias,
    usuario: state.auth.usuario
});

export default connect(mapStateToProps, { ...actionsCategorias, ...actionsProdutos })(NovoProduto);